import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';

export const LoadingHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70px;
  border-bottom: ${(props) => (props.showUnderline ? `0.1rem solid ${colors.lightGray11}` : 'none')};
`;

export const ResultsColumn = styled.div`
  font-family: lato, sans-serif;
  font-weight: 400;
  line-height: 1.8rem;
  word-break: break-all;
  display: inline-flex;
  align-items: center;
  padding-right: 10px;
  font-size: 12px;
  width: ${(props) => props.width || 'auto'};
`;

export const ResultsColumnGrey = styled(ResultsColumn)`
  color: ${colors.darkGray9};
`;

export const CheckBoxColumn = styled.div`
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  margin-right: 7px;
`;

export const Checkbox = styled.input`
  margin: 0 15px 0 15px !important;
  border-radius: 0;
  stroke: ${colors.blackText} !important;
  stroke-width: 2px;
  &:hover {
    cursor: pointer;
  }
`;

export const ResultRowOrders = styled.div`
  width: 100%;
  color: ${(props) => (props.checked ? colors.blackText : colors.darkGray9)};
  border-bottom: 1px solid ${colors.lightGray11};
  display: flex;
  padding: 17px 0;
  background-color: ${(props) => (props.markAsOrder ? colors.selectedMessageBackground : colors.baseBackground)};

  & td {
    padding: 8px;
    line-height: 1.42857;
    vertical-align: top;
  }
`;

export const ResultRowItems = styled.div`
  color: ${colors.blackText};
  border-bottom: 0;
  display: flex;
  padding: 5px 0;
  margin-left: 50px;

  & td {
    padding: 8px;
    line-height: 1.42857;
    vertical-align: top;
  }
`;

export const ResultItemContainer = styled.div`
  padding: 10px 0;
  background-color: ${(props) => (props.markAsOrder ? colors.selectedMessageBackground : colors.baseBackground)};
`;
